import { render, staticRenderFns } from "./news1.vue?vue&type=template&id=0e2643db&scoped=true"
import script from "./news1.vue?vue&type=script&lang=js"
export * from "./news1.vue?vue&type=script&lang=js"
import style0 from "./news1.vue?vue&type=style&index=0&id=0e2643db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2643db",
  null
  
)

export default component.exports